import React, { useState } from 'react';
import { handleError, isProd } from '../shared/Functions';
import ReCAPTCHA from "react-google-recaptcha";
import { CaptchaService, UserUtilityVService } from '../../services/V2/keymaster';
import { Button, Dialog, DialogActions, DialogContent, TextField } from '@material-ui/core';

export function ForgotUsername({ setShow, fail, success }) {
    const recaptchaRef: any = React.useRef();
    
    const [user, setUser] = useState<any>();
    const [verrified, setVerified] = useState<boolean>(false);

    const handleChange = event => {
        let name = event.target.id;
        let value = event.target.value === "" ? null : event.target.value;
        
        setUser({
            ...user,
            [name]: value
        })
    }

    const send = async () => {
        if(verrified){
            UserUtilityVService.userUtilityVUsernameRecoveryAdmin(user)
                .then(x => {
                    success("Check your email for your Username.")
                    hide();
                })
                .catch(x => fail(handleError(x)))
        } else {
            const token = await recaptchaRef?.current?.executeAsync();
            CaptchaService.captchaValidate(token)
                .then(x => {
                    if(x.success) {
                        setVerified(true)
                        UserUtilityVService.userUtilityVUsernameRecoveryAdmin(user)
                            .then(x => {
                                success("Check your email for your Username.")
                                hide();
                            })
                            .catch(x => fail(handleError(x)))
                    } else {
                        fail("An error occurred while verifying you are human.")
                    }
                })
        }
    }

    const hide = () => {
        setShow(false)
    }

    return <>
        <Dialog onClose={hide} open={true}>
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={isProd() ? "6LdysiEhAAAAAPZwsLD0CCf4U8yJvrD6pkuGuTHw" : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
            />
            <DialogContent>
                <h5>Forgot Username</h5>
                <TextField
                    onChange={handleChange}
                    margin="normal"
                    id="email"
                    label="Email"
                    type="text"
                    value={user?.email ?? ""}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={hide}>
                    Cancel
                </Button>
                <Button onClick={send}>
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    </>
}
